module.exports = "/explore/client/f0605f03fa478593f75f791e8eea8889.svg";